import { Dialog } from 'radix-ui'
import { useHostConfig } from '../../../../hooks/use-host-config'

import './tickets-step.scss'

const CLASS_NAME = 'game-type-help-modal'

type GameTypeHelpModalProps = {
  open: boolean
  onClose: () => void
}

export const GameTypeHelpModal = ({ open, onClose }: GameTypeHelpModalProps) => {
  const hostConfig = useHostConfig()
  const gameTypeHelp = hostConfig.claimFormConfig?.gameTypeHelp

  if (!gameTypeHelp) {
    return null
  }

  return (
    <Dialog.Root open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={`${CLASS_NAME}__overlay`} />
        <Dialog.Content className={CLASS_NAME} aria-describedby={undefined}>
          <Dialog.Close asChild>
            <button type="button" className={`${CLASS_NAME}__close`} aria-label="Close">
              &times;
            </button>
          </Dialog.Close>
          <Dialog.Title className={`${CLASS_NAME}__title`}>{gameTypeHelp.title}</Dialog.Title>
          <section className={`${CLASS_NAME}__content`}>{gameTypeHelp.content}</section>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
